import get from 'lodash/get';
import { all, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getFileHandlingRequest } from '../../../api/Workflow/files/getFileHandlingQuery';
import * as businessConst from '../businessConst';

export function* getTransportInformationWorker({ payload }) {
  const fileId = get(payload, 'fileId');

  if (!fileId) {
    return;
  }

  yield executeSagaRequest(
    businessConst.GET_TRANSPORT_INFO,
    getFileHandlingRequest({ fileId }),
    { fileId },
  );
}

function* getTransportInformationWatcher() {
  yield takeEvery(
    businessConst.GET_TRANSPORT_INFO.BASE,
    getTransportInformationWorker,
  );
}

export default function* transportSaga() {
  try {
    yield all([getTransportInformationWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
